export default function getFormattedLocale(locale: string) {
  return ['한국어', '영어', '중국어', '일본어', '베트남어'].find((v) => v === locale) || '한국어';
}
